import Bowser from "bowser";
import $ from "jquery";
import "slick-carousel";
import Headroom from "headroom.js";
import MicroModal from "micromodal";


// GSAP 
// Heros
import animateHomeHero from "./home/homeHero";
import animateServicesHero from "./services-archive/servicesHero";
import animateServiceHero from "./service-single/serviceHero";
import animateContactHero from "./contact/contactHero";
import animateHeroA from "./global/heroA";

// Global Sections
import animateCenteredTextBlock from "./global/centeredTextBlock";
import animateCenteredTextBlockB from "./global/centeredTextBlockB";
import animateTextSplit from "./global/textSplit";
import animateTextBlockSplit from "./global/textBlockSplit";
import animateTextImageSplit from "./global/textImageSplit";
import animateTextImageSplitB from "./global/textImageSplitB";
import animateTextImageSplitSlider from "./global/textImageSplitSlider";
import animateMultiColumnBlockGrid from "./global/multiColumnBlockGrid";
import animateMultiColumnGrid from "./global/multiColumnGrid";
import animateBlockGrid from "./global/blockGrid";
import animateIconGrid from "./global/iconGrid";
import animateFullWidthRow from "./global/fullWidthRow";

// Page-Specific Sections
import animateHomeTextImageSplit from "./home/homeTextImageSplit";
import animateHomeNews from "./home/homeNews";
import animateStatsSection from "./about/statsSection";
import animateStaffSection from "./about/staffSection";
import animateContactForm from "./contact/contactForm";
import animatePostGrid from "./index/postGrid";

// Headroom
let siteHeader = document.querySelector(".site-header"),
  headroom = new Headroom(siteHeader);

headroom.init();

$(document).ready(function() {
  // Inside of this function, $() will work as an alias for jQuery()
  // and other libraries also using $ will not be accessible under this shortcut
  // https://codex.wordpress.org/Function_Reference/wp_enqueue_script#jQuery_noConflict_Wrappers

  // Touch Device Detection
  var isTouchDevice = "ontouchstart" in document.documentElement;
  if (isTouchDevice) {
    $("body").removeClass("no-touch");
  }

  // Browser detection via Bowser (https://github.com/lancedikson/bowser) - add detection as needed
  const userBrowser = Bowser.getParser(window.navigator.userAgent);
  const browser = userBrowser.getBrowser();

  if (browser.name === "Internet Explorer" && browser.version == "11.0") {
    $("body").addClass("ie-11");
  } else if (browser.name === "Safari") {
    $("body").addClass("safari");
  }

  // Helper functions
  function toggleMask() {
    $("html").toggleClass("locked");
    $("body").toggleClass("locked masked");
  }

  function removeMask() {
    $("html").removeClass("locked");
    $("body").removeClass("locked masked");
  }

  function toggleMenu(icon, menu) {
    icon.toggleClass("active");
    menu.slideToggle();
  }

  function closeMenu(icon, menu) {
    icon.removeClass("active");
    menu.slideUp();
  }

  // Menus 
  // Menu - Toggle on click or enter key
  $(".menu-icon").on("click", function() {
    toggleMask();

    toggleMenu($(this), $(".site-header__mobile-panel"));
  });

  // Menu - close on resize to desktop
  $(window).on("resize", function() {
    if( $(window).width() > 1024 && $(".site-header__mobile-panel").css("display") == "block" ) {
      removeMask(); 

      closeMenu($(".menu-icon"), $(".site-header__mobile-panel"));
    }
  });
  
  // Menu - Close on outside click 
  $(document).on("click", function(e) {
    if( !$(e.target).closest(".site-header").length && $(".site-header__mobile-panel").css("display") == "block" ) {
      removeMask();

      closeMenu($(".menu-icon"), $(".site-header__mobile-panel"));
    }
  });

  // Menu - Close on ESC
  $(document).on("keyup", function(e) {
    if( e.which == 27 ) {
      if( $(".nav--mobile").css("display") == "block" ) {
        removeMask();

        closeMenu($(".menu-icon"), $(".site-header__mobile-panel"));
      }
    }
  });

  // Menu - Mobile accordions 
  $(".nav--mobile .menu-item-has-children > a").on("click", function(e) {
    e.preventDefault();

    $(this).toggleClass("open");
    $(this).siblings(".sub-menu").slideToggle();
  });

  // Hero Sections
  // Home hero GSAP
  if( $(".hero--home").length ) {
    let section = document.querySelector(".hero--home"),
      textLines = section.querySelectorAll(".animate-line");
    
    // params: section, textLines
    animateHomeHero(section, textLines);
  }

  // Services Hero GSAP
  if( $(".hero--services").length ) {
    let section = document.querySelector(".hero--services"),
      img = section.querySelector(".hero--services__img img"),
      textLines = section.querySelectorAll(".animate-line"),
      hr = section.querySelector(".animated-hr");

    // params: section, img, textLines, hr
    animateServicesHero(section, img, textLines, hr)
  }

  // Service Hero GSAP 
  if( $(".hero--service").length ) {
    let section = document.querySelector(".hero--service"),
      img = section.querySelector(".hero--service__img img");

    // params: section, img
    animateServiceHero(section, img)
  }

  // Property Hero GSAP 
  if( $(".hero--property").length ) {
    let section = document.querySelector(".hero--property"),
      img = section.querySelector(".hero--property__img img");

    // params: section, img
    animateServiceHero(section, img)
  }

  // Contact Hero GSAP 
  if( $(".hero--contact").length ) {
    let section = document.querySelector(".hero--contact"),
      hr = section.querySelector(".hero--contact__line"),
      textLines = section.querySelectorAll(".animate-line"),
      items = section.querySelectorAll(".hero--contact__item"),
      buttons = section.querySelector(".buttons");

    // params: section, hr, textLines, items, buttons
    animateContactHero(section, hr, textLines, items, buttons);
  }

  // Hero A GSAP
  if( $(".hero--a").length ) {
    let section = document.querySelector(".hero--a"),
      img = section.querySelector(".hero--a__img"),
      line = section.querySelector(".hero--a__line"),
      textLines = section.querySelectorAll(".animate-line"),
      buttons = section.querySelector(".buttons");

    // params: section, img, line, textLines, buttons
    animateHeroA(section, img, line, textLines, buttons);
  }

  // Home News GSAP
  if ($(".news-grid--home").length ) {
    let section = document.querySelector(".news-grid--home"),
      hr = section.querySelectorAll(".animated-hr");

    // params: section, hr
    animateHomeNews(section, hr);
  }

  // Global Sections
  // Centered Text Block GSAP
  if( $(".centered-text-block").length ) {
    $(".centered-text-block").each(function() {
      // Section elements
      let section = document.querySelector(".centered-text-block"),
        block = section.querySelector(".centered-text-block__block"),
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        line = section.querySelector(".centered-text-block__line"),
        buttons = section.querySelector(".buttons");

      // params: section, block, textLines, hr, line, buttons
      animateCenteredTextBlock(section, block, textLines, hr, line, buttons);
    });
  }

  // Centered Text Block B GSAP
  if( $(".centered-text-block--b").length ) {
    $(".centered-text-block--b").each(function() {
      // Section elements
      let section = this,
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        widget = section.querySelector(".centered-text-block--b__search"),
        buttons = section.querySelector(".buttons");

      // params: section, textLines, hr, widget, buttons
      animateCenteredTextBlockB(section, textLines, hr, widget, buttons);
    });
  }

  // Text Split GSAP
  if( $(".text-split").length ) {
    $(".text-split").each(function() {
      // Section elements
      let section = this,
        line = section.querySelector(".text-split__line"),
        textLines = section.querySelectorAll(".animate-line"),
        buttons = section.querySelector(".buttons");

      // params: section, line, textLines, buttons
      animateTextSplit(section, line, textLines, buttons);
    });
  }

  // Text Block Split GSAP
  if( $(".text-block-split").length ) {
    $(".text-block-split").each(function() {
      // Section elements
      let section = this,
        blocks = section.querySelectorAll(".g-col-6"),
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr");

      // params: section, blocks, textLines, hr
      animateTextBlockSplit(section, blocks, textLines, hr);
    });
  }

  // Text/Image Split GSAP (Global version)
  if( $(".text-image-split").length ) {
    $(".text-image-split").each(function() {
      // Section elements
      let section = this,
        img = section.querySelector(".text-image-split__shape"),
        number = section.querySelector(".text-image-split__number-group"),
        line = section.querySelector(".text-image-split__line-home"),
        hr = section.querySelectorAll(".animated-hr"),
        textLines = section.querySelectorAll(".animate-line"),
        buttons = section.querySelector(".buttons");

      // params: section, img, number, line, hr, textLines, buttons
      animateTextImageSplit(section, img, number, line, hr, textLines, buttons);
    });
  }

  // Text/Image Split B GSAP
  if( $(".text-image-split--b").length ) {
    $(".text-image-split--b").each(function() {
      // Section elements
      let section = this,
        img = section.querySelector(".text-image-split--b__img"),
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        buttons = section.querySelector(".buttons");

      // params: section, img, textLines, hr, buttons
      animateTextImageSplitB(section, img, textLines, hr, buttons);
    });
  }

  // Text/Image Split Slider GSAP 
  if( $(".text-image-split-slider").length ) {
    $(".text-image-split-slider").each(function() {
      let section = this,
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        buttons = section.querySelector(".buttons");

      // params: section, textLines, hr, buttons
      animateTextImageSplitSlider(section, textLines, hr, buttons);
    });
  }

  // Text/Image Split Slider (Slick)
  if( $(".text-image-split-slider__images").length ) {
    $(".text-image-split-slider__images").slick({
      arrows: false,
      dots: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  }

  // Multi-Column Block Grid GSAP
  if( $(".multi-column-block-grid").length ) {
    $(".multi-column-block-grid").each(function() {
      // Section elements
      let section = this,
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        blocks = section.querySelectorAll(".multi-column-block-grid__block");

      // params: section, textLines, hr, blocks
      animateMultiColumnBlockGrid(section, textLines, hr, blocks);
    });
  }

  // Multi-Column Grid GSAP
  if( $(".multi-column-grid").length ) {
    $(".multi-column-grid").each(function() {
      // Section elements
      let section = this,
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr"),
        blocks = section.querySelectorAll(".multi-column-grid__block"),
        buttons = section.querySelector(".buttons");

      // params: section, textLines, hr, blocks, buttons
      animateMultiColumnGrid(section, textLines, hr, blocks, buttons);
    });
  }

  // Block Grid GSAP 
  if( $(".block-grid").length ) {
    $(".block-grid").each(function() {
      let section = this,
        textLines = section.querySelectorAll(".animate-line"),
        blocks = section.querySelectorAll(".block-grid__tile");

      // params: section, textLines, blocks
      animateBlockGrid(section, textLines, blocks);
    });
  }

  // Block Grid Slider (Slick)
  if( $(".block-grid-slider").length ) {
    $(".block-grid-slider__slider").slick({
      arrows: true,
      appendArrows: $(".block-grid-slider__arrows"),
      dots: true,
      appendDots: $(".block-grid-slider__dots"),
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: false,
          }
        }
      ]
    });
  }

  // Icon Grid GSAP
  if( $(".icon-grid").length ) {
    $(".icon-grid").each(function() {
      // Section elements
      let section = this,
        icons = section.querySelectorAll(".icon-grid__tile"),
        textLines = section.querySelectorAll(".animate-line"),
        hr = section.querySelectorAll(".animated-hr");

      // params: section, textLines, hr, icons
      animateIconGrid(section, textLines, hr, icons);
    });
  }

  // Full-Width Row GSAP 
  if( $(".full-width-row").length ) {
    $(".full-width-row").each(function() {
      let section = this,
        block = section.querySelector(".g-col-12");

      // params: section, block
      animateFullWidthRow(section, block);
    });
  }

  // Full-Width Slider (Slick)
  if( $(".full-width-slider__slides").length ) {
    $(".full-width-slider__slides").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      adaptiveHeight: false,
      appendArrows: $(".full-width-slider__nav"),
    });
  }
  
  // Full-Width Slider (Slick)
  if( $(".full-width-slider__slides-property").length ) {
    $(".full-width-slider__slides-property").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      adaptiveHeight: true,
      slidesToShow: 1.3,
      centerMode: true,
      infinite: false,
      centerPadding: '100px',
      appendArrows: $(".full-width-slider__nav"),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: '0',
          }
        },
      ]
    });
  }

  // Text/Image Split List
  if ($(".text_image_split_list").length) {
    let section = document.querySelector(".text_image_split_list"),
      hr = section.querySelectorAll(".animated-hr");

    // params: section, hr
    animateHomeNews(section, hr);
  }

  // Page-Specific Sections
  // Home Text Image Split 1 GSAP 
  if( $(".text-image-split--home--full").length ) {
    let section = document.querySelector(".text-image-split--home--full"),
      img = section.querySelector(".text-image-split--home--full__shape"),
      number = section.querySelector(".text-image-split--home--full__number-group"),
      textLines = section.querySelectorAll(".animate-line"),
      hr = section.querySelector(".animated-hr"),
      buttons = section.querySelector(".buttons");

    // params: section, img, number, textLines, hr, buttons
    animateHomeTextImageSplit(section, img, number, textLines, hr, buttons);
  }

  // Home Text Image Split 2 GSAP 
  if( $(".text-image-split--home").length ) {
    let section = document.querySelector(".text-image-split--home"),
      img = section.querySelector(".text-image-split--home__shape"),
      number = section.querySelector(".text-image-split--home__number-group"),
      textLines = section.querySelectorAll(".animate-line"),
      hr = section.querySelector(".animated-hr"),
      buttons = section.querySelector(".buttons");

    // params: section, img, number, textLines, hr, buttons
    animateHomeTextImageSplit(section, img, number, textLines, hr, buttons);
  }

  // About Stats Section GSAP 
  if( $(".stats-section").length ) {
    let section = document.querySelector(".stats-section"),
      textLines = section.querySelectorAll(".animate-line"),
      blocks = section.querySelectorAll(".stats-section__block");

    // params: section, textLines, blocks
    animateStatsSection(section, textLines, blocks);
  }

  // About Staff Section GSAP 
  if( $(".staff-section").length ) {
    let section = document.querySelector(".staff-section"),
      founderImg = section.querySelector(".staff-section__founder-img"),
      founderBlock = section.querySelector(".staff-section__founder-block"),
      line = section.querySelector(".staff-section__line"),
      grid = section.querySelector(".staff-section__grid"),
      tiles = section.querySelectorAll(".staff-section__tile");

    // params: section, founderImg, founderBlock, line, grid, tiles
    animateStaffSection(section, founderImg, founderBlock, line, grid, tiles);   
  }

  // Contact Form Section GSAP 
  if( $(".contact-form-section").length ) {
    let section = document.querySelector(".contact-form-section"),
      textLines = section.querySelectorAll(".animate-line"),
      form = section.querySelector(".gform_wrapper");

    // params: section, textLines, form
    animateContactForm(section, textLines, form);
  }

  // Post Grid GSAP 
  if( $(".post-grid").length ) {
    let section = document.querySelector(".post-grid"),
      textLines = section.querySelectorAll(".animate-line"),
      hr = section.querySelector(".animated-hr"),
      tiles = section.querySelectorAll(".post-tile");

    // params: section, textLines, tiles
    animatePostGrid(section, textLines, hr, tiles);
  }

  //load more toggle
  $('#show-more').on('click', function(){
    $('.hidden-post').fadeIn(300);
    $('#show-more').fadeOut();
    $('#see-posts').fadeIn();
  });

  //load more toggle (list)
  $('#show-more-list').on('click', function(){
    $('.hidden-list-row').fadeIn(300);
    $('#show-more-list').fadeOut();
    $('.no-line').removeClass('no-line');
  });

  //Scrolling text banner
  var $tickerWrapper = $(".tickerwrapper");
  var $list = $tickerWrapper.find("ul.list");
  var $clonedList = $list.clone();
  var listWidth = 5;

  $list.find("li").each(function (i) {
    listWidth += $(this, i).outerWidth(true);
  });

  var endPos = $tickerWrapper.width() - listWidth;

  $list.add($clonedList).css({
    "width": listWidth + "px"
  });

  $clonedList.addClass("cloned").appendTo($tickerWrapper);

  //TimelineMax
  var infinite = new TimelineMax({ repeat: -1, paused: true });
  var time = 40;

  infinite
    .fromTo($list, time, { rotation: 0.01, x: 0 }, { force3D: true, x: -listWidth, ease: Linear.easeNone }, 0)
    .fromTo($clonedList, time, { rotation: 0.01, x: listWidth }, { force3D: true, x: 0, ease: Linear.easeNone }, 0)
    .set($list, { force3D: true, rotation: 0.01, x: listWidth })
    .to($clonedList, time, { force3D: true, rotation: 0.01, x: -listWidth, ease: Linear.easeNone }, time)
    .to($list, time, { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone }, time)
    .progress(1).progress(0)
    .play();

  function stopVideo() {
    var videos = $('iframe');
    videos.each(function (index) {
      var iframe = videos[index];
      var iframeSrc = iframe.src;
      iframe.src = '';
      iframe.src = iframeSrc;
    });
  };

  MicroModal.init({
    onClose: modal => stopVideo(),
    onShow: modal => stopVideo(),
  });
  
});

